var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipsWatched({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9387,
    cy: 20,
    rx: 19.9387,
    ry: 20,
    fill: "#FDCB6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4625 19.6294L14.4081 13.1019C14.2597 13.0281 14.0949 12.9934 13.9294 13.001C13.7638 13.0087 13.6029 13.0585 13.462 13.1456C13.321 13.2328 13.2046 13.3545 13.1237 13.4991C13.0429 13.6438 13.0003 13.8068 13 13.9725V27.0269C13.0003 27.1926 13.0428 27.3556 13.1237 27.5003C13.2045 27.645 13.3209 27.7666 13.4619 27.8538C13.6029 27.9409 13.7639 27.9906 13.9294 27.9981C14.095 28.0057 14.2598 27.9708 14.4081 27.8969L27.4625 21.37C27.6241 21.2892 27.76 21.1649 27.855 21.0112C27.95 20.8575 28.0003 20.6804 28.0003 20.4997C28.0003 20.319 27.95 20.1419 27.855 19.9882C27.76 19.8344 27.6241 19.7102 27.4625 19.6294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsWatched);
export default __webpack_public_path__ + "static/media/tips-watched.26e37c82e26df6c63a559d6161b33e5c.svg";
export { ForwardRef as ReactComponent };